<template>
  <div class="Feb2022 text-NotoSansLight py-12 md:py-16">
    <div class="main container-book px-4">
      <div class="fixed-btn fixed z-50 hidden xl:block">
        <a class="cursor-pointer block px-3"><img src="~@/assets/images/202202/menu-off_01.png" class="object-contain"></a>
        <a @click="toTop(0)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202202/menu-off_02.png" class="off object-contain">
          <img src="~@/assets/images/202202/menu-on_02.png" class="on object-contain">
        </a>
        <a @click="toTop(1)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202202/menu-off_03.png" class="off object-contain">
          <img src="~@/assets/images/202202/menu-on_03.png" class="on object-contain">
          </a>
        <a @click="toTop(2)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202202/menu-off_04.png" class="off object-contain">
          <img src="~@/assets/images/202202/menu-on_04.png" class="on object-contain">
        </a>
        <a @click="toTop(3)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202202/menu-off_05.png" class="off object-contain">
          <img src="~@/assets/images/202202/menu-on_05.png" class="on object-contain">
        </a>
        <a @click="toTop(4)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202202/menu-off_06.png" class="off object-contain">
          <img src="~@/assets/images/202202/menu-on_06.png" class="on object-contain">
        </a>
        <a @click="toTop(5)" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202202/menu-off_07.png" class="off object-contain">
          <img src="~@/assets/images/202202/menu-on_07.png" class="on object-contain">
        </a>
        <a href="https://store.liveabc.com/products/recent/sale?tag=139" target="_blank" class="hover-item cursor-pointer block px-3">
          <img src="~@/assets/images/202202/menu-off_08.png" class="off object-contain">
          <img src="~@/assets/images/202202/menu-on_08.png" class="on object-contain">
        </a>
      </div>
      <section class="banner mb-4">
        <div class="flex px-3">
          <div class="px-6">
            <div class="mb-3"><img src="~@/assets/images/202202/master-title.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div><img src="~@/assets/images/202202/student-pic.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          </div>
          <div class="px-4 flex flex-col justify-between items-center pb-6">
            <div data-aos="zoom-in" data-aos-once="true"><img src="~@/assets/images/202202/bubble box.png" class="object-contain"></div>
            <div><img src="~@/assets/images/202202/DATE-title.png" class="object-contain"></div>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-1/2 md:w-1/4 p-3" data-aos-delay="100" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202202/6-box.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <div class="w-1/2 md:w-1/4 p-3" data-aos-delay="200" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202202/300-box.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <div class="w-1/2 md:w-1/4 p-3" data-aos-delay="300" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202202/2000-box.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <div class="w-1/2 md:w-1/4 p-3" data-aos-delay="400" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202202/3000-box.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
        </div>
      </section>

      <section class="py-4 mb-4">
        <div class="mb-5">
          <img src="~@/assets/images/202202/secondary-title.png" class="object-contain mx-auto">
        </div>
        <a class="mb-10 block" href="https://store.liveabc.com/products/recent/sale?tag=139" target="_blank">
          <img src="~@/assets/images/202202/livePEN-box.png" class="object-contain mx-auto">
        </a>
        <div class="mb-5">
          <img src="~@/assets/images/202202/third-title.png" class="object-contain mx-auto">
        </div>
        <div class="flex flex-wrap">
          <a @click="toTop(index)" class="hover-item w-1/2 md:w-1/3 p-2 md:p-3 cursor-pointer" v-for="(item, index) in bookList" :key="index">
            <img :src="item.img_url" class="object-contain mx-auto off">
            <img :src="item.img_url_on" class="object-contain mx-auto on">
          </a>
        </div>
      </section>
      <section class="section py-4" v-for="(item, index) in sectionData" :key="index" :id="'section' + index">
        <div class="flex justify-between items-center mb-8">
          <div class="pr-2 md:pr-4">
            <img :src="item.img_url" class="object-contain mx-auto">
          </div>
          <div class="w-10 md:flex-1 border-t-2 border-white h-0 border-dotted"></div>
          <a :href="item.link" class="pl-2 md:pl-4 more" target="_blank">
            <img src="~@/assets/images/202202/more-button-off.png" class="off object-contain mx-auto">
            <img src="~@/assets/images/202202/more-button-on.png" class="on object-contain mx-auto">
          </a>
        </div>

        <div class="flex flex-wrap">
          <div class="w-1/2 md:w-1/3 lg:w-1/4 py-3 px-2">
            <a :href="item.link" target="_blank" class="item-card rounded-3xl p-3 h-full flex items-center justify-center cursor-pointer" :style="{ 'background-color': item.item_bg }">
              <img :src="item.item_img_url" class="object-contain mx-auto">
            </a>
          </div>
          <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }"  class="item w-1/2 md:w-1/3 lg:w-1/4 p-3 cursor-pointer" v-for="(child, idx) in item.items" :key="idx">

            <div class="item-inner bg-white rounded-3xl p-3 h-full flex flex-col justify-between hover:shadow-xl shadow-gray-900" v-if="renderComponent">
              <div>
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                    <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
                <div>
                  <div class="title p-1 rounded-lg lg:rounded-full mb-3">
                    <h6 class="text-white text-center text-sm">{{ child.introduction }}</h6>
                  </div>
                  <div>
                    <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                  </div>
                </div>
              </div>

              <div class="flex flex-col md:flex-row md:justify-center md:items-end mt-3 flex-wrap" v-if="child.name">
                <p v-if="child.type === 'PACKAGE'" class="fixed_price">原價:{{ child.fixed_price }}</p>
                <p v-if="child.type === 'BOOK'">{{ child.display_discount }}折</p>
                <p class="hidden md:block">&emsp;</p>
                <p class="text-lg pricing">特價:{{ child.pricing }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </section>

      <section class="section6 py-3 pl-6 px-2">
        <ul class="list-decimal list-outside leading-loose text-white text-base lg:text-lg font-light tracking-wider">
          <li>活動期間2022.2.11~2022.3.31於LiveABC官方網站購買商品，<br/>訂單成立後即可參加「LiveABC開學書展滿額回饋」活動。<br/>消費滿額300元送「Pepe桑的唱遊世界」 繪本書乙本，價值350元(數量有限，送完為止)<br/>消費滿額2,000元，結帳金額現折150元<br/>消費滿額3,000元，結帳金額現折350元</li>
          <li>於活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格。</li>
          <li>詳細活動時間與內容以LiveABC官網發布為主 (<router-link :to="{ name: 'index' }" href="">https://store.liveabc.com/</router-link>)。</li>
        </ul>
      </section>

      <footer class="section6 pt-20 pb-12 flex justify-center">
        <router-link :to="{ name: 'index' }" class="block mx-auto">
          <img class="object-contain" src="~@/assets/images/202202/logo.png" alt="livaABC">
        </router-link>
      </footer>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import jump from 'jump.js'
import dealBookName from '@/components/modules/dealBookName'
export default {
  name: 'Feb2022',
  metaInfo () {
    return {
      title: 'LiveABC開學書展_打造英語學爸霸',
      titleTemplate: null
    }
  },
  components: {
    dealBookName
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: true,
      renderComponent: true,

      bookList: [
        { img_url: require('@/assets/images/202202/kids-button.png'), img_url_on: require('@/assets/images/202202/kids-button-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=102' },
        { img_url: require('@/assets/images/202202/primary-school-button.png'), img_url_on: require('@/assets/images/202202/primary school-button-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=113' },
        { img_url: require('@/assets/images/202202/middle-school-button.png'), img_url_on: require('@/assets/images/202202/middle school-button-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=101' },
        { img_url: require('@/assets/images/202202/Junior-College-button.png'), img_url_on: require('@/assets/images/202202/Junior-College-button-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=103' },
        { img_url: require('@/assets/images/202202/social-elite-button.png'), img_url_on: require('@/assets/images/202202/social-elite-button-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=110' },
        { img_url: require('@/assets/images/202202/Discount.png'), img_url_on: require('@/assets/images/202202/Discount-on.png'), link: 'https://store.liveabc.com/products/book?type=BOOK&category=111' }
      ],

      sectionData: [
        {
          img_url: require('@/assets/images/202202/01-title.png'),
          item_img_url: require('@/assets/images/202202/01-pic.png'),
          item_bg: '#D7F01B',
          link: 'https://store.liveabc.com/products/recent/sale?tag=134',
          items: [
            { id: 7068, introduction: '佩佩豬陪孩子打基礎' },
            { id: 7235, introduction: '孩子最愛的英語教材' },
            { id: 6935, introduction: '孩子生活中的必備單字' }
          ]
        },
        {
          img_url: require('@/assets/images/202202/02-title.png'),
          item_img_url: require('@/assets/images/202202/02-pic.png'),
          item_bg: '#f0b4d5',
          link: 'https://store.liveabc.com/products/recent/sale?tag=135',
          items: [
            { id: 5936, introduction: '年度最熱銷兒童英語教材' },
            { id: 6561, introduction: '看故事學英語超有趣' },
            { id: 7445, introduction: '圖解單字+好用句+情境會話' }
          ]
        },
        {
          img_url: require('@/assets/images/202202/03-title.png'),
          item_img_url: require('@/assets/images/202202/03-pic.png'),
          item_bg: '#80d7ce',
          link: 'https://store.liveabc.com/products/recent/sale?tag=136',
          items: [
            { id: 7482, introduction: '建立英文素養題組寫作能力' },
            { id: 6771, introduction: '會考學測英檢必考單字書' },
            { id: 6772, introduction: '累積單字量成績一定好' },
            { id: 7573, introduction: '理科學霸必備知識圖解百科' },
            { id: 7218, introduction: '最新學測題型教戰本' },
            { id: 6610, introduction: '迅速累積會考英語字彙量' },
            { id: 7220, introduction: '各種必考閱讀題型總整理' }
          ]
        },
        {
          img_url: require('@/assets/images/202202/04-title.png'),
          item_img_url: require('@/assets/images/202202/04-pic.png'),
          item_bg: '#96f288',
          link: 'https://store.liveabc.com/products/recent/sale?tag=137',
          items: [
            { id: 6568, introduction: '雅思拿高分的必備秘笈' },
            { id: 6609, introduction: '考前衝刺必備模考試題' },
            { id: 7512, introduction: '引領你邁向金色證書之路' },
            { id: 7399, introduction: '看心智圖提升單字記憶力' },
            { id: 6779, introduction: '最有效率多益備考計畫' },
            { id: 5910, introduction: '解題拿高分技巧大公開' },
            { id: 6032, introduction: '讀西洋經典文學閱讀力升級' }
          ]
        },
        {
          img_url: require('@/assets/images/202202/05-title.png'),
          item_img_url: require('@/assets/images/202202/05-pic.png'),
          item_bg: '#c2d2f2',
          link: 'https://store.liveabc.com/products/recent/sale?tag=138',
          items: [
            { id: 7386, introduction: '學會英語簡報關鍵用語' },
            { id: 7412, introduction: '學好新聞英語與世界接軌' },
            { id: 7388, introduction: '各種商務場合實戰說英語' },
            { id: 6681, introduction: '教你看懂國際英美新聞報刊' },
            { id: 7647, introduction: '辦公情境英語速效學習' },
            { id: 7208, introduction: '學習道地的生活英語' },
            { id: 6769, introduction: '會話影片融入教學情境' }
          ]
        },
        {
          img_url: require('@/assets/images/202202/06-title.png'),
          item_img_url: require('@/assets/images/202202/06-pic.png'),
          item_bg: '#575ff2',
          link: 'https://store.liveabc.com/products/recent/sale?tag=140',
          items: [
            { id: 5413, introduction: '40大全景圖解課程' },
            { id: 4922, introduction: '核心題型答題秘訣' },
            { id: 5711, introduction: '全彩實物字彙圖解' },
            { id: 5813, introduction: '你的英語私人家教超大牌' },
            { id: 5712, introduction: '豐富例句情境說明' },
            { id: 3885, introduction: '最有料的日語學習書' },
            { id: 5207, introduction: '場景對話教你怎麼用' }
          ]
        }
      ]
    }
  },
  async mounted () {
    await this.getEvent()
  },
  destroyed () {
  },
  methods: {
    async getEvent () {
      let self = this
      for (let i = 0; i < self.sectionData.length; i++) {
        await self.getData(i, self.sectionData[i].items)
      }
    },
    getData (idx, itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }

      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`#section${n}`, {
        duration: 500,
        offset: 0
      })
    },
    replace (name) {
      return name.replace(' ', '<br/>')
    }
  }
}
</script>
<style lang="scss" scoped>
.container-book {
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.pricing {
  color: #ff0000;
}

.outer {
  position: relative;
  width: 100%;
  background:white;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.title {
  background-color: #f02973;
}
.Feb2022 {
  background-color: #f02973;
  background-image: url('~@/assets/images/202202/pattern.png');
  background-size: contain;
  background-attachment: fixed;
  .main {
    .fixed-btn {
      top: 50%;
      transform: translateY(-50%);
      right: 5%;
      transition: 0.3s;
    }
    .bg-yellow {
      background-color: #D7F01B;
    }
    .more {
      .on {
        display: none;
      }
      &:hover {
        .off {
          display: none;
        }
        .on {
          display: block;
        }
      }
    }
    .item-card {
      min-height: 360px;
    }
    .item {
      .item-inner {
        min-height: 360px;
        transition: .3s;
        &:hover {
          transform: translateY(-15px);
        }
      }
    }
    .hover-item {
      .on {
        display: none;
      }
      &:hover {
        .off {
          display: none;
        }
        .on {
          display: block;
        }
      }
    }
  }
}
</style>
